import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-70961682"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "snapshot-wrap"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭");

import { computed, ref, watch } from 'vue';
import { getActivityEditRecordDetail } from '@/request';
import ActivityUpdate from '../activity-update.vue';
export default {
  name: 'ActivityEditRecordDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    recordId: {
      type: [Number, String],
      default: undefined
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const loading = ref(false);
    const snapshot = ref(null);
    watch(() => props.modelValue, val => {
      if (val) {
        loadDetail();
      } else {
        snapshot.value = null;
      }
    });

    function loadDetail() {
      if (!props.recordId) {
        snapshot.value = null;
        return;
      }

      loading.value = true;
      getActivityEditRecordDetail({
        recordId: props.recordId,
        __warn: true
      }).then(res => {
        snapshot.value = res.data || null;
      }).finally(() => {
        loading.value = false;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "活动快照详情",
        width: "96%",
        top: "2vh",
        "destroy-on-close": "",
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [snapshot.value && _unref(visible) ? (_openBlock(), _createBlock(ActivityUpdate, {
          key: 0,
          "embed-mode": "",
          "embed-snapshot": snapshot.value
        }, null, 8, ["embed-snapshot"])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};